import { request } from '@/utils/request'

function unpackAll(content) {
    const users = []
    content.users.forEach(u => (users[u.id] = u))
    const notes = content.notes
    notes.forEach(n => (n.user = users[n.userId]))
    return notes
}

function unpackSingle(content) {
    const note = content.note
    note.user = content.user
    return note
}

export default {
    async listByEntityTypeAndEntityId(entityType, entityId) {
        let content = await request.get(`/api/manage/data-entry-notes/${entityType}/${entityId}`)
        content = unpackAll(content)
        return content
    },
    async create(note) {
        const response = await request.post(`/api/manage/data-entry-notes`, note)
        if (response.ok) {
            response.content = unpackSingle(response.content)
        }
        return response
    },
    async update(note) {
        const response = await request.put(`/api/manage/data-entry-notes/${note.id}`, note)
        if (response.ok) {
            response.content = unpackSingle(response.content)
        }
        return response
    },
    destroy(noteOrId) {
        return request.delete(`/api/manage/data-entry-notes/${noteOrId.id ?? noteOrId}`)
    },
}
